import { Model } from '../parents/model';

export class CustomerCommentsModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_COMMENT = 'comment';
  static ATTR_CREATED_AT = 'created_at';

  static EMBED_USER_NAME = 'user_name';

  get id() {
    return this.attributes[CustomerCommentsModel.ATTR_ID];
  }
  get comment() {
    return this.attributes[CustomerCommentsModel.ATTR_COMMENT];
  }
  get createdAt() {
    return this.attributes[CustomerCommentsModel.ATTR_CREATED_AT];
  }

  get userName() {
    return this.embeds[CustomerCommentsModel.EMBED_USER_NAME];
  }
}
